module.exports = __webpack_public_path__ + "media/images/lb/200-dd3cb0972ff025662a54e5fb79e90a5c.svg";